module.exports = __webpack_public_path__ + "img/slide8.a7b96277.jpg";